import AddLocation from './AddLocationContainer';

export default AddLocation;
